import { render, staticRenderFns } from "./ShippingHistoryListItemId.vue?vue&type=template&id=318e8194"
import script from "./ShippingHistoryListItemId.vue?vue&type=script&lang=js"
export * from "./ShippingHistoryListItemId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports